import './header.component.scss'
import './navigation.scss'
import './navigation.js'
import './dropdown.scss'
import './dropdown.js'
import './search/search.scss'
import './search/search.js'
import { Swiper, Navigation, Scrollbar, Mousewheel, Autoplay } from 'swiper'
Swiper.use([Navigation, Scrollbar, Mousewheel, Autoplay])

const globalNotify = document.querySelector('.header__notify')
const headerSwiperElement = document.querySelector('.header__slider')
let lastScrollTop = 0;

if (globalNotify) {
  const toggleScroll = () => {
    document.documentElement.classList.toggle(
      'is-scroll',
      globalNotify.getBoundingClientRect().height < window.scrollY
    )
    const st = window.pageYOffset || document.documentElement.scrollTop
    const scrMax = document.documentElement.scrollHeight - document.documentElement.clientHeight
    if (st > lastScrollTop){
      document.documentElement.classList.remove('is-scroll-up')
    } else if(st + 100 < scrMax){
      document.documentElement.classList.add('is-scroll-up')
    }
    lastScrollTop = st <= 0 ? 0 : st;
  }
  window.addEventListener('scroll', toggleScroll)
  toggleScroll()
  if(headerSwiperElement){
    new Swiper(headerSwiperElement.querySelector('.swiper-container'), {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      mousewheel: {
        forceToAxis: true
      },
      speed: 500,
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false
      },
      navigation: {
        prevEl: headerSwiperElement
          .querySelector('.swiper-buttons button[data-prev]'),
        nextEl: headerSwiperElement
          .querySelector('.swiper-buttons button[data-next]')
      }
    })
  }
} else {
  document.documentElement.style.setProperty('--header-notify-height', '0')
}
